import { Empty, EmptyProps } from "antd";
import EmptyImage from "../../assets/images/empty.svg";

export default function CustomEmpty({
  imageStyle,
  className = "",
  ...rest
}: EmptyProps) {
  return (
    <Empty
      image={EmptyImage}
      imageStyle={{ marginBottom: 0, ...imageStyle }}
      description
      className={`flex justify-center ${className}`}
      {...rest}
    />
  );
}
